/**
 * Customer-facing contact address for Voxium Script.
 *
 * This is the single source of truth. Every customer-facing surface
 * (contact lines on legal pages, support links, inline "email us"
 * references, etc.) MUST import from here. Changing the address is a
 * one-line edit in this file; do not hardcode it anywhere else.
 *
 * NOT this address:
 *   - auth@voxiumscript.com  (SES transactional sender, not a contact
 *     mailbox — leave untouched wherever it appears)
 */
export const SUPPORT_EMAIL = "info@raymarcoenterprises.com";
